<template>
  <div class="page-wrapper">

    <div class="background-page" style="overflow-y: scroll">
      <slider animation="fade" style="height:200px; margin-top:47px;">
        <slider-item
          v-for="(img, index) in images"
          :key="index"
          style="z-index: 0; height:200px;"

        >
          <div class="restaurant-image" style="height:200px;" v-bind:style="{backgroundImage: 'url(' + img + ')'}"></div>
        </slider-item>
      </slider>

      <div class="container" style="padding-bottom: 100px;">
        <div class="row" v-if="merchantItem != false" style="margin-top: 20px; font-size: 12px;">
          <div class="col-12">
            <div class="address" v-html="merchantItem.address.replace(/\n/g, '<br>')">

            </div>
            <div class="telephone">
              <a :href="'tel:' + merchantItem.contact">{{merchantItem.contact}}</a>
            </div>
          </div>
        </div>

        <div v-if="registered == false">
          <div class="row" style="margin-top: 20px;">
            <div class="col-12">
              <h5>{{merchantItem.title}}</h5>
              <h6>Visitor Record Form</h6>
            </div>
            <div class="col-12" v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.visitor_instruction !== null && merchantItem.webSetting.visitor_instruction.length > 0">
              <p>{{merchantItem.webSetting.visitor_instruction}}</p>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-12">
              <input type="text" class="form-control" v-model="name" placeholder="Name"/>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-12">
              <input type="tel" class="form-control" v-model="phoneNumber" placeholder="Phone Number"/>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-12">
              <button type="button" class="btn btn-primary form-control" v-on:click="submit">Submit</button>
            </div>
          </div>
        </div>
<!--        <template v-else>-->
<!--          <div class="row" style="margin-top: 20px;">-->
<!--            <div class="col-12">-->
<!--              <h3>Show this page to staff.</h3>-->
<!--            </div>-->
<!--            <div class="col-12">-->
<!--              <div v-html="registered"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--        <div class="row" style="margin-top: 20px;">-->

<!--          <div class="col-12">-->
<!--            <p v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.visitor_tnc !== null && merchantItem.webSetting.visitor_tnc.length > 0">-->
<!--              {{merchantItem.webSetting.visitor_tnc}}-->
<!--            </p>-->
<!--            <p v-else style="font-size: 12px;">Your contact information will be kept as confidential data with data encryption for 21 days from submission according to UK government visitor economy guidance.-->
<!--              Your contact details will be provided only to NHS when NHS request to provide only in matter of Covid-19.<br>-->
<!--&lt;!&ndash;              <a href="https://www.gov.uk/guidance/maintaining-records-of-staff-customers-and-visitors-to-support-nhs-test-and-trace" target=”_blank”>GOV.UK guidance</a>&ndash;&gt;-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->


        <div v-else-if="registeredItem !== false">
          <div class="row" style="margin-top: 20px;">
            <div class="col-12">
              Thank you for submission.
              <div v-html="registered"></div>
            </div>
            <div class="col-12">
              <p v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.visitor_instruction_post !== null && merchantItem.webSetting.visitor_instruction_post.length > 0">
                {{merchantItem.webSetting.visitor_instruction_post}}
              </p>
              <p v-else>

              </p>
            </div>
          </div>
          <div class="row" style="margin-top: 5px;">
            <div class="col-12">
              <span v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.table_title !== null && merchantItem.webSetting.table_title.length > 0">
                {{merchantItem.webSetting.table_title}}
              </span>
              <input v-model="registeredItem.seat" class="form-control" style="height: 50px; line-height: 50px; text-align: center; font-size: 30px; font-weight: bold;"/>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-12">
              <button class="btn btn-success form-control" v-on:click="submitSeat">
                COMPLETE
              </button>
            </div>
          </div>
        </div>
        <div v-if="completedItem !== false">
          <div class="row" style="margin-top:20px;">
            <div class="col-12">
              <h3>Registration Completed</h3>
            </div>
            <div class="col-12">
              <p v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.visitor_completion_text !== null && merchantItem.webSetting.visitor_completion_text.length > 0">
                {{merchantItem.webSetting.visitor_completion_text}}
              </p>
            </div>
            <div class="col-12">
              <table class="table">
                <tr>
                  <td>
                    Name:
                  </td>
                  <td>
                    {{completedItem.namEnc}}
                  </td>
                </tr>
                <tr>
                  <td>
                    Contact:
                  </td>
                  <td>
                    {{completedItem.phoneNumberEnc}}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.table_title !== null && merchantItem.webSetting.table_title.length > 0">
                      {{merchantItem.webSetting.table_title}}
                    </span>
                    <span v-else>Seat/Table</span>
                  </td>
                  <td>
                    {{completedItem.seat}}

                  </td>
                </tr>
                <tr>
                  <td>
                    Date/Time:
                  </td>
                  <td>
                    {{readableTime(completedItem.createdTimestamp)}}
                  </td>
                </tr>

              </table>

            </div>
            <div class="col-12" style="margin-top:10px;">
              <button class="btn btn-dark form-control" @click="restartSession">FINISH</button>
            </div>

          </div>
        </div>
      </div>
      <Bottom v-if="merchantItem != false"
              :item="merchantItem">

      </Bottom>
    </div>
    <div class="loading-background" v-if="isLoading">
      <div class="wrapper">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <span>{{loadingMessage}}</span>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<script>
    import EventBus from "../api/event-bus";

    import Bottom from "./Bottom";
    require('@/assets/css/styles.css')
    import {getMerchant, registerVisitor, setVisitorSeat} from "../api/borium";
    import Router from '../router';
    import {millisToReadable} from "../api/utils";
    import {Slider, SliderItem} from "vue-easy-slider";
    export default {
        name: "Visitor",
        data() {
          return {
            animDuration: 300,
            merchantItem:false,
            images:[],
            name:'',
            phoneNumber: '',
            registered:false,
            isLoading:false,
            loadingMessage:'Registering...',
            registeredItem: false,
            completedItem: false,
            finished: false,
          }
        },
        components: {
          Slider,
          SliderItem,
          Bottom,
        },
      created() {
        // console.log("URL: " + window.location.host)
        // if(window.location.host !== 'eemo.app' && window.location.host !== 'showmethemenu.net' && window.location.host !== 'localhost:8090') {
        //   this.$data.commonDomain = false;
        //
        // }
        this.getMerchantItem();
      },
      mounted() {
        if(this.$data.commonDomain == true) {
          EventBus.$emit("setTitle", "");
        } else {
          EventBus.$emit("setTitle", "Hi");
        }
        EventBus.$emit("modeChanged", 0);
        $("#nav-top").removeClass("transparent-background");
      },
      methods: {
          readableTime: millisToReadable,
        getMerchantItem: function () {

          if(this.$route.params.hasOwnProperty('id') == false) {
            return;
          }
          // console.log("visitor restaurant id " + this.$route.params.hasOwnProperty('id'));


          let self = this;
          self.setLoadingView(true, "Getting restaurant...");
          getMerchant(this.$route.params.id)
            .then(function (data) {
              self.setLoadingView(false);
              console.log(data);
              if (data.success) {
                self.$data.merchantItem = data.item;
                self.setMerchant();
              } else {
                self.showDialog("Could not get place information", "ERROR");
              }
            })
            .catch(function (err) {
              self.setLoadingView(false);
              // console.log(err);
              self.showDialog("Error occurred. Close this page and rescan QR code. If issue is not resolved, please ask member of staff.", "ERROR");
            })

        },
        setMerchant: function() {
          console.log("set merchant");
          console.log(this.$data.merchantItem);
          EventBus.$emit("setTitle", this.$data.merchantItem.title);
          if(this.$data.merchantItem.imageUrl !== null && this.$data.merchantItem.imageUrl.length > 0) {
            this.$data.images = this.$data.merchantItem.imageUrl.split(',');
          }
          this.setPageMeta();
        },
        setLoadingView: function(show, message = '') {
          this.$data.isLoading = show;
          this.$data.loadingMessage = message;
        },
        submit: function() {
          if(this.$data.name === null || this.$data.name === '' || this.$data.name.length < 2) {
            this.showDialog("Please enter name with at least 2 characters");
            return;
          }

          if(this.$data.phoneNumber === null) {
            this.showDialog("Please enter 11 digit phone number starting with 07");
            return;
          }
          if(this.$data.phoneNumber === '') {
            this.showDialog("Please enter 11 digit phone number starting with 07");
            return;
          }
          if(this.$data.phoneNumber.toString().startsWith("07") === false) {
            this.showDialog("Phone number should start with 07");
            return;
          }
          if(this.$data.phoneNumber.length !== 11) {
            this.showDialog("Phone number should be 11 digit");
            return;
          }
          if(this.$data.phoneNumber === null || this.$data.phoneNumber === '' || this.$data.phoneNumber.toString().startsWith("07") === false || this.$data.phoneNumber.length !== 11) {
            // console.log(this.$data.phoneNumber + " length " + this.$data.phoneNumber.length + " starting with 07 " + this.$data.phoneNumber.toString().startsWith("07"));
            this.showDialog("Please enter 11 digit phone number starting with 07")
            return;
          }

          let visitor = {
            id:0,
            name:this.$data.name,
            phoneNumber:this.$data.phoneNumber,
            merchantId:this.$data.merchantItem.merchantId,
          }

          // console.log("visitor");
          let self = this;

          this.$data.name = '';
          this.$data.phoneNumber = '';
          this.setLoadingView(true, "Sending data..");
          registerVisitor(visitor)
          .then(function(data) {
            self.setLoadingView(false);
            console.log(data);
            if(data.success == true) {
              console.log(data.item);
              self.$data.registeredItem = data.item;
              self.$data.registered = 'Your detail is now securely stored.<br>Registered time:<h2 class="big-time">' + millisToReadable(data.item.createdTimestamp) + '</h2>';

            } else {

            }
          })
          .catch(function(err) {
            self.setLoadingView(false);
            console.log("Failed to register " + err);
            if(err.response != undefined) {
              console.log(err.response);
            }
          })

        },
        restartSession: function() {
          this.$data.name = "";
          this.$data.phoneNumber = "";
          this.$data.registeredItem = false;
          this.$data.completedItem = false;
          this.$data.registered = false;
        },
        submitSeat: function() {
          if(this.$data.registeredItem === false) {
            return;
          }

          let now = new Date().getTime();
          if(now - this.$data.registeredItem.creaatedTimestamp > 60*60000) {
            this.showDialog("It has been more than 1 hour<br/>Please submit new visitor form.");
            this.restartSession();
            return;
          }
          let self = this;
          if(this.$data.registeredItem.seat === null && this.$data.registeredItem.seat.length === 0) {
            let tabletitle = 'Table/Seat';
            if(this.merchantItem.webSetting !== undefined && this.merchantItem.webSetting !== null && this.merchantItem.webSetting.table_title !== null && this.merchantItem.webSetting.table_title.length > 0) {
              tabletitle = this.merchantItem.webSetting.table_title;
            }
            this.showDialog(tabletitle + " is required");
            return;
          }
          // console.log("Now update seat");
          // console.log(this.$data.registeredItem);
          setVisitorSeat(this.$data.registeredItem)
          .then(function(data) {
            // console.log("seat update");
            // console.log(data);
            if(data.success === true) {
              self.$data.registeredItem = false;
              self.$data.completedItem = data.item;
              console.log(self.$data.completedItem);
            } else {
              self.showDialog(data.message);
            }
          })
          .catch(function(err) {
            // console.log(err);
            // if(err.response !== undefined) {
            //   console.log(err.response);
            // }
            self.showDialog("Unknown error occurred. Scan QR Code and restart. Sorry for inconveniences", "ERROR");
          })
        },
        setPageMeta: function() {
          const titleEl = document.querySelector('head title');
          const descEl = document.querySelector('head meta[name="description"]');
          const keywordsEl = document.querySelector('head meta[name="keywords"]');

          let title =this.$data.merchantItem.title;
          let key = this.$data.merchantItem.title;

          // let description = "Simple click and collect & Takeaway and delivery order for " + this.$data.merchantItem.title;
          // if(this.$data.merchantItem.region !== undefined && this.$data.merchantItem.region != null && this.$data.merchantItem.region.length > 0) {
          //   title += " in " + this.$data.merchantItem.region;
          //   key += "," + this.$data.merchantItem.region;
          //   description += " in " + this.$data.merchantItem.region;
          // }
          // key += ", takeaway, delivery";
          // if(this.$data.merchantItem.tags !== undefined && this.$data.merchantItem.tags != null && this.$data.merchantItem.tags.length > 0) {
          //   key += "," + this.$data.merchantItem.tags;
          // }
          // title += " Takeaway | Delivery | Menu | Price | Show Me The Menu";
          titleEl.textContent = title;

          // descEl.setAttribute('content', description);
          // keywordsEl.setAttribute('content', key);
          if(this.$data.merchantItem.webSetting !== undefined
            && this.$data.merchantItem.webSetting != null
            && this.$data.merchantItem.webSetting.icon != null
            && this.$data.merchantItem.webSetting.icon.startsWith("https://")) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = this.$data.merchantItem.webSetting.icon;
          }
        },
        showDialog: function(message, title = '') {
          let params = {
            title:title,
            text:message
          }
          this.$modal.show('dialog', params);
        }

      }
    }
</script>

<style scoped>
.big-time {
  font-size: 60px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Visitor.vue